var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75583 8.30613H14.1568C17.3842 8.30613 20 10.9234 20 14.1526C20 17.3817 17.3842 20 14.1568 20H10.4343C9.84755 20 9.3724 19.5236 9.3724 18.9365C9.3724 18.3495 9.84755 17.8741 10.4343 17.8741H14.1568C16.2108 17.8741 17.8753 16.2077 17.8753 14.1525C17.8753 12.0974 16.2108 10.432 14.1568 10.432H6.75583L9.15445 12.8319C9.59074 13.2675 9.59074 13.9751 9.15445 14.4107C8.71916 14.8462 8.0129 14.8462 7.57661 14.4107L3.32722 10.1579C2.89093 9.72234 2.89093 9.01569 3.32722 8.57916L7.57661 4.3274C8.0129 3.89087 8.71916 3.89087 9.15445 4.3274C9.59074 4.76293 9.59074 5.46959 9.15445 5.90612L6.75583 8.30613Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.cd84a1626552d3b117964f79f254e093.svg";
export { ForwardRef as ReactComponent };